import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getRelated } from '../reducers';
import RelatedBlockItem from '../components/RelatedBlockItem';
import { contentTypes } from '../langMap';

class RelatedBlock extends Component { //eslint-disable-line
  render() {
    const { color, type, related, lang } = this.props;
    const style = {
      color,
    };
    if (related.length === 0) {
      return null;
    }
    return (
      <div className="related-block">
        {
          lang === 'ar' ?
            <h3 style={style} className="related-block__title">{contentTypes[type]}</h3> :
            <h3 style={style} className="related-block__title">{type}</h3>
        }
        <div className="related-block__list">
          { related.map(item => <RelatedBlockItem key={item.id} {...item} />) }
        </div>
      </div>
    );
  }
}


RelatedBlock.propTypes = {
  color: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  related: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = (state, { contentId, type }) => ({
  related: getRelated(state, contentId, type),
});

RelatedBlock = connect( //eslint-disable-line
  mapStateToProps,
  actions,
)(RelatedBlock);

export default RelatedBlock;



// WEBPACK FOOTER //
// ./js/containers/RelatedBlock.js